import * as mediabunny from "../../node_modules/mediabunny/dist/bundles/mediabunny.mjs";

export const ALL_FORMATS: typeof import("mediabunny").ALL_FORMATS =
	mediabunny.ALL_FORMATS;
export const BlobSource: typeof import("mediabunny").BlobSource =
	mediabunny.BlobSource;
export const BufferTarget: typeof import("mediabunny").BufferTarget =
	mediabunny.BufferTarget;
export const Conversion: typeof import("mediabunny").Conversion =
	mediabunny.Conversion;
export const Input: typeof import("mediabunny").Input = mediabunny.Input;
export const Mp4InputFormat: typeof import("mediabunny").Mp4InputFormat =
	mediabunny.Mp4InputFormat;
export const Mp4OutputFormat: typeof import("mediabunny").Mp4OutputFormat =
	mediabunny.Mp4OutputFormat;
export const Output: typeof import("mediabunny").Output = mediabunny.Output;
